import React, { Component } from "react";
import Form from "../WalkIn/Form";
import { makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import axios from "axios";

class EditWalkIn extends Component {
  errors = {};

  constructor(props) {
    super(props);
    makeObservable(this, {
      errors: observable
    });
  }

  submit(data, cardFront, cardBack) {
    const { id } = this.props.entry;
    const formData = new FormData();

    formData.append("card_front", cardFront);
    formData.append("card_back", cardBack);
    formData.append("place", JSON.stringify(data.place));
    formData.append("notes", data.notes);
    formData.append("availability", data.availability);

    axios
      .patch(`/pro/walk_ins/${id}`, formData, {
        headers: {
          "content-type": "multipart/form-data"
        }
      })
      .then(() => {
        alert("Success!");
        window.location = "/pro/walk_ins";
      })
      .catch(({ response }) => {
        const body = response.data;
        this.errors = body.data;
      });;
  }

  render() {
    const { id, place, attachments, notes, entry_info } = this.props.entry;
    const cardFront = attachments.length >= 1 ? attachments[0].url : null;
    const cardBack = attachments.length >= 1 ? attachments[1].url : null;
    return (
      <Form
        place={place}
        notes={notes}
        availability={entry_info.availability}
        cardFront={cardFront}
        cardBack={cardBack}
        onSubmit={this.submit.bind(this)}
        errors={this.errors}
      />
    );
  }
}

export default observer(EditWalkIn);
